var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", [
      _c("div", { staticClass: "card mt-3 bg-statusWarning" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row mb-2" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "span",
                {
                  staticClass: "mb-0 pb-0",
                  attrs: {
                    "data-test-hook": "expired-dealer-subscription-header"
                  }
                },
                [
                  _c("i", {
                    staticClass: "far fa-triangle-exclamation pr-1",
                    attrs: { "data-test-hook": "titleIcon" }
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "1rem",
                        "font-weight": "bold"
                      },
                      attrs: { "data-test-hook": "account-needs-attention-txt" }
                    },
                    [_vm._v(_vm._s(_vm.$t("xYourAccountNeedsAttentionHeader")))]
                  )
                ]
              )
            ])
          ]),
          _c("div", { staticClass: "row mb-2 ml-2" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "span",
                {
                  attrs: {
                    "data-test-hook":
                      "expired-dealer-subscription-banner-body-text"
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("xExpiredDealerManagedPlanBodyText", {
                          apparatusName: _vm.expiredDealerManagedApparatus.name
                        })
                      ) +
                      " "
                  )
                ]
              )
            ])
          ]),
          _c("div", { staticClass: "row mb-1 ml-2" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-contact-support",
                  attrs: {
                    type: "button",
                    "data-test-hook": "openSupportPageBtn"
                  },
                  on: {
                    click: function($event) {
                      return _vm.navigateToContactSupportPage()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("xContactSupport")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-warning btn-contact-dealer ml-2",
                  attrs: {
                    type: "button",
                    "data-test-hook": "openPreferredDealerPageBtn"
                  },
                  on: {
                    click: function($event) {
                      return _vm.navigateToContactYourDealer()
                    }
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "xRemoteMonitoringExpiredBodyDealerManagedContactDealer"
                        )
                      ) +
                      " "
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ]),
    _vm.expiredDealerManagedApparatus &&
    _vm.expiredDealerManagedApparatus.apparatusId
      ? _c(
          "div",
          {
            staticClass: "modal fade show",
            attrs: {
              id:
                "dealer-managed-sub-expired" +
                _vm.expiredDealerManagedApparatus.apparatusId,
              role: "dialog"
            }
          },
          [
            _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
              _c("span", { attrs: { tabindex: "0" } }),
              _c(
                "div",
                { staticClass: "modal-content", attrs: { tabindex: "-1" } },
                [
                  _c("header", { staticClass: "modal-header" }, [
                    _c(
                      "div",
                      {
                        staticClass: "row w-100 no-gutters align-items-center"
                      },
                      [
                        _c("div", { staticClass: "col" }, [
                          _c("h2", { staticClass: "modal-title" }, [
                            _c("i", {
                              staticClass:
                                "far fa-exclamation-triangle colorOrange mr-1"
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("xYourAccountNeedsAttentionHeader")
                                ) +
                                " "
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "float-right col-auto" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-icon-button--gray btn-icon-button",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.closeDealerModal()
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-times" })]
                          )
                        ])
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "modal-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "xYourDealerManagedSubscriptionHasExpiredContactDealer"
                              )
                            ) +
                            " "
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "row pt-3" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("strong", [
                          _vm._v(
                            " " + _vm._s(_vm.$t("xDealerInformation")) + " "
                          )
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "col pt-1" }, [
                      _c("div", { staticClass: "row pb-1" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.expiredDealerManagedApparatus
                                .preferredDealerName
                            ) +
                            " "
                        )
                      ]),
                      _c("div", { staticClass: "row" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.expiredDealerManagedApparatus
                                .preferredDealerPhone
                            ) +
                            " "
                        )
                      ]),
                      _c("div", { staticClass: "row" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.expiredDealerManagedApparatus
                                .preferredDealerEmail
                            ) +
                            " "
                        )
                      ])
                    ])
                  ]),
                  _c("ModalFooter", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.navigateToContactSupportPage()
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("xContactSupportUpgrade")) + " "
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }